import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import H3 from '../H3';

const CustomH3 = styled(H3)`
  ${tw`text-left p-0 m-0 cursor-pointer user-select-none`};
`;

export { CustomH3 };
